import type { Contact, SavedLocation } from '@hero/schema';
import { useTranslation } from 'react-i18next';
import { useSavedLocationListApi } from '@hero/api-hooks';
import { DrawerContentList } from '../../../app/Drawer/DrawerContentList';
import { SharedList } from '../../../app/List/List';
import { ContactClientCard } from '../Card/ContactClientCard';
import { SavedLocationCard } from '../../SavedLocation/Card/SavedLocationCard';

export interface ContactSummaryTabProps {
  contact: Contact;
}

export function ContactSummaryTab({ contact }: ContactSummaryTabProps) {
  const { t } = useTranslation(['m-contact']);

  const locationsQuery = useSavedLocationListApi({ contactId: contact._id });

  return (
    <div className="flex flex-col px-5 py-2">
      <DrawerContentList
        list={[
          { label: t('drawer.fields.name'), value: contact.name || '-' },
          { label: t('drawer.fields.phone'), value: contact.phone || '-' },
          { label: t('drawer.fields.email'), value: contact.email || '-' },
        ]}
      />

      {contact.clients && contact.clients.length > 0 && (
        <div className="mt-6">
          <h4 className="text-sm font-medium text-gray-500 mb-3">
            {t('drawer.sections.clients', { defaultValue: t('drawer.sections.customers') })}
          </h4>
          <div className="flex flex-col gap-2">
            {contact.clients.map(client => (
              <ContactClientCard key={String(client._id)} client={client} />
            ))}
          </div>
        </div>
      )}

      <div className="mt-6">
        <h4 className="text-sm font-medium text-gray-500 mb-3">
          {t('drawer.sections.locations')}
        </h4>
        <SharedList<SavedLocation>
          query={locationsQuery}
          emptyMessage={t('drawer.no_locations')}
          className="gap-2"
          renderItem={location => <SavedLocationCard savedLocation={location} />}
        />
      </div>
    </div>
  );
}
